// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__OrYMl","buttons":"Footer_buttons__3xZR0"};